export enum ErrorCode {
	unauthorized = 'unauthorized',
	unauthenticated = 'unauthenticated',
}

export type ServiceError = string | { id: string };
